import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  active: { c: "#22C55E", label: "Active" },
  approved: { c: "#22C55E", label: "Approved" },
  sale: { c: "#22C55E", label: "Sale" },
  revshare: { c: "#F59E0B", label: "RevShare" },
  redep: { c: "#2DD4BF", label: "Redep" },
  completed: { c: "#22C55E", label: "Completed" },
  success: { c: "#22C55E", label: "Success" },
  unique: { c: "#22C55E", label: "Unique" },
  public: { c: "#22C55E", label: "Public" },
  lead: { c: "#A78BFA", label: "Lead" },
  hold: { c: "#EAB308", label: "Hold" },
  new: { c: "#38BDF8", label: "New" },
  in_progress: { c: "#EAB308", label: "In Progress" },
  pending: { c: "#EAB308", label: "Pending" },
  processing: { c: "#38BDF8", label: "Processing" },
  warning: { c: "#EAB308", label: "Warning" },
  duplicate: { c: "#EAB308", label: "Duplicate" },
  private: { c: "#A1A1AA", label: "Private" },
  request: { c: "#38BDF8", label: "Request" },
  trash: { c: "#71717A", label: "Trash" },
  disabled: { c: "#EF4444", label: "Disabled" },
  rejected: { c: "#EF4444", label: "Rejected" },
  archived: { c: "#EF4444", label: "Archived" },
  error: { c: "#EF4444", label: "Error" },
};

export function StatusBadge({ status, className, label }) {
  const key = String(status || "").toLowerCase();
  const base = MAP[key] || { c: "#A1A1AA", label: status || "—" };
  const cfg = label ? { ...base, label } : base;
  return (
    <span
      data-testid={`status-${key}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        className,
      )}
      style={{
        color: cfg.c,
        borderColor: `${cfg.c}33`,
        backgroundColor: `${cfg.c}14`,
      }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: cfg.c }} />
      {cfg.label}
    </span>
  );
}
